export default __webpack_public_path__ + "static/media/manual_Ar.da0dac72.pdf";